<template>
    <div class="cat_conter" :id="'option'+idx">
        <div class="conter_top">
            <div class="testpaper-question-tit-wrap">
                <div class="testpaper-question-tit">{{idx+1}}</div>
                <div class="testpaper-question-score">{{parentData.topic_score}}.0分</div>
            </div>
            <div class="testpaper-question-topic clearfix">
                <div v-html="strcharacterDiscode(parentData.topic_stem)"></div>
                <!-- <p v-html="dt"></p> -->
                <br />
            </div>
        </div>
        <ul class="testpaper-question-choices" v-for='(sub_item,sub_key) in parentData.topic_metas' :key="sub_key">
            <li @click="multipleData(sub_key,idx,parentData.topic_id)" ref="all_sub">
                <span class="">{{option[sub_key]}}</span>
                <p v-html="strcharacterDiscode(sub_item)"></p>
            </li>
        </ul>
    </div>
</template>

<script>
    import strcharacterDiscode from '@/js/strcharacterDiscode'

    export default {
        props:['parentData','idx'],
        data(){
            return {
                option: ['A','B','C','D','E','F','G','H','I','J'],
                isactive : -1,
                selectIndex: []
            }
        },
        created() {
            this.selectIndex[this.idx]=[];
            // console.log(this.parentData,222222);
            // this.parentData.topic_stem=`${this.parentData.topic_stem}`;
        },
        methods: {
            multipleData(index,idx,key) {
                
                if(this.selectIndex[idx].indexOf(index) >= 0) {
                    for(var i=0;i<this.selectIndex[idx].length;i++){
                        this.selectIndex[idx][i]===index && this.selectIndex[idx].splice(i,1);
                    }
                    this.$refs.all_sub[index].children[0].className=''
                }else {
                    this.selectIndex[idx].push(index);
                    this.$refs.all_sub[index].children[0].className='active' //绑定dom
                }

                if(this.selectIndex[idx].length>0){
                    document.querySelector("#card"+idx).className="active";
                }else{
                    document.querySelector("#card"+idx).className="";
                }
                
                // console.log(this.selectIndex,3333)
                this.$emit('multipleData',[this.selectIndex[idx],key])
            },
            strcharacterDiscode
        }
    }
</script>

<style scoped>
    .testpaper-question-tit-wrap{
        float: left;
        margin-right: 10px;
    }
    .testpaper-question-tit-wrap{
        text-align: center;
    }
    .testpaper-question-tit{
        font-size: 20px;
        color: #3a87ad;
    }
    .testpaper-question-score {
        font-size: 12px;
        color: #aaa;
        border: 1px solid #ccc;
        padding: 0 1px;
        border-radius: 5px;
        background: #f6f6f6;
        display: inline-block;
    }
    .testpaper-question-topic {
        border-bottom: 1px dashed #ddd;
        margin-bottom: 10px;
        overflow: hidden;
        zoom: 1;
    }
    .active{
        background: rgb(105, 153, 117) !important;
        color: #fff !important;
    }
</style>




// WEBPACK FOOTER //
// src/components/MultipleChoice.vue